import MangoPageBlock from './templates/MangoPageBlock.vue';
import Page8800 from './templates/Page8800.vue';

import {pascalCaseToKebab} from "../base.js"
import { createApp } from 'vue'

let template = window['NumbersPageBlockData']['template'];

if (template === 'MangoPageBlock') {
    let appData = Object.assign({}, window[MangoPageBlock.name+'Data']);
    const app = createApp(MangoPageBlock, appData);
    app.mount('#'+pascalCaseToKebab(MangoPageBlock.name))
} else {
    let appData = Object.assign({}, window[Page8800.name+'Data']);
    const app = createApp(Page8800, appData);
    app.mount('#'+pascalCaseToKebab(Page8800.name))
}
